import { useContext } from "react";
import { ProjectMeasureContext } from "./project-measure-context-props.ts";

export const useOptionaleProjectMeasureContext = () => useContext(ProjectMeasureContext);

const useProjectMeasureContext = () => {
    const context = useContext(ProjectMeasureContext);
    if (context == null)
        throw new Error('Must be defined in ProjectMeasureProvider');
    return context;
};

export default useProjectMeasureContext;